import { Modal } from "@/components/elements/Modal";
import { FC } from "react";

type TPublishConfirmInformationModalProps = {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
};

export const PublishConfirmInformationModal: FC<TPublishConfirmInformationModalProps> = ({ open, onClose, onOk }) => {
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title="お知らせを公開してよろしいですか？"
      height={146}
      labelClose="キャンセル"
      labelOk="公開する"
      onOk={onOk}
    />
  );
};
